import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/scans',
      name: 'scans',
      component: () => import('@/views/scans/Scans.vue'),
      meta: {
        pageTitle: 'Scans',
        breadcrumb: [
          {
            text: 'Scans',
            active: true,
          },
        ],
      },
    },
   
  
    {
      path: '/order-item/:id',
      name: 'orderItemView',
      component: () => import('@/views/orders/OrderItemViewer.vue'),
      meta: {
        pageTitle: 'Voir Order Item',
        breadcrumb: [
          {
            text: 'Voir Order Item',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/profile',
    //   name: 'profile',
    //   component: () => import('@/views/profile/Profile.vue'),
    //   meta: {
    //     pageTitle: 'Profile',
    //     breadcrumb: [
    //       {
    //         text: 'Profile',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/orders/Orders.vue'),
      meta: {
        pageTitle: 'Orders',
        breadcrumb: [
          {
            text: 'Orders',
            active: true,
          },
        ],
      },
    },
    {
      path: '/orders/detail/:id',
      name: 'orderDetail',
      component: () => import('@/views/orders/OrderDetail.vue'),
      meta: {
        pageTitle: 'Order',
        breadcrumb: [
          {
            text: 'Order',
            active: true,
          },
        ],
      },
    },
    
    
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
